<template>
  <div>
    <Breadcrumb :title="`Allocation Detail:`"></Breadcrumb>
    <div>
      <div class="form-row">
        <div class="form-group col-md-12">
          <label class="section-title">Investment : {{displayFields.Investment}}</label><br>
          <label class="section-title">Program : {{displayFields.Program}}</label><br>
          <label class="section-title">Period : {{displayFields.Period}}</label>
        </div>
      </div>
    </div>
    <BaseSearchBar :config="SearchUnitProgramAllocation" @keyupSearch="filterGrid"></BaseSearchBar>
    <BaseToolBar
      :config="UnitProgramAllocationDetailToolBarConfig"
      @buttonClicked="UnitProgramAllocationDetailToolBarClick"
    ></BaseToolBar>
    <BaseGrid
      :mode="'editform'"
      :excelExport="excelExport"
      :config="DetailGridConfig"
      :data="ProgramDetailGridData"
    ></BaseGrid>
  </div>
</template>

<script>
// Breadcrumb implementation
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import $ from "jquery";

// Base Searchbar Implementation
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import funcUtil from "@/services/funcUtil.js";
import deepGroupBy from "@/services/groupByUtil.js";

// Base Toolbar Implementation
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import {
  DetailGridConfig,
  DetailToolBarConfig
} from "./UnitProgramAllocation.js";

import BaseModelAllocation from "@/models/BaseModelAllocation.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";

// Base Grid Implementation
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import { isNullOrUndefined, isString, isNumber } from "util";
import linq from "linq";

export default {
  name: "UnitProgramAllocationDetail",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  components: {
    Breadcrumb,
    BaseSearchBar,
    BaseToolBar,
    BaseGrid
  },
  computed: {
    ...mapGetters("getModule", [
      "withFilter",
      "getAllItemFilter",
      "getLocalInputControls",
      "GetValueByKey"
    ])
  },

  data: function() {
    return {
      // Base Grid implementation
      DetailGridConfig: DetailGridConfig,
      UnitProgramAllocationDetailGridId: DetailGridConfig.grid.gridId,
      UnitProgramAllocationDetailMasterData: [],

      // Base Toolbar with button implementation
      UnitProgramAllocationDetailToolBarConfig: DetailToolBarConfig,

      // Base Searchbar implementation
      SearchUnitProgramAllocation: {
        SearchData: ""
      },

      investmentId: this.$route.params.investmentId,

      displayFields: {
        Investment: "",
        Program: "",
        Period: ""
      },

      BaseModelInputControl: BaseModelInputControl,
      BaseModelAllocation: BaseModelAllocation,

      ProgramDetailGridData: []
    };
  },

  // beforeRouteUpdate(to, from, next) {
  //   this.investmentId = to.params.investmentId;
  //   this.displayFields.Program = to.params.programTitle;
  //   this.displayFields.Period = to.params.taxQuarter;

  //   if (this.investmentId) {
  //   } else {
  //   }
  //   next();
  // },

  mounted() {
    const self = this;
    // Tool bar grid setting
    // self._loadGridSettings(self.UnitProgramAllocationDetailGridId);

    //Bind databound event to grid
    var grid = $("#" + self.UnitProgramAllocationDetailGridId).data(
      "kendoGrid"
    );
    grid.bind("dataBound", self.UpdateUnitProgramAllocationDetailMasterData);
    self.investmentId = self.GetValueByKey("InvestmentId")
    self.displayFields.Program = self.GetValueByKey("Title")
    //self.displayFields.Investment = self.GetValueByKey("InvestmentTitle")
    self.displayFields.Period = self.GetValueByKey("TaxYearQuarter")
    self.getBaseGridData();
    

    if(self.displayFields.Program == '' || self.investmentId == '' || self.displayFields.Period == ''){
      self.backtoSummary();
    }
  },

  methods: {
    ...mapActions("postModule", [
      "CreateAllItems",
      "deleteAllItem",
      "UpdateAllItems",
      "CreateJoinedItems"
    ]),

    async getBaseGridData() {
      const self = this;
      await self.getProgramGridData();
      self._loadGridSettings(self.UnitProgramAllocationDetailGridId);
    },

    backtoSummary: function() {
      this.$router.push("/valuation/allocation");
    },

    UpdateUnitProgramAllocationDetailMasterData: function(
      fromFilter,
      filterMasterData
    ) {
      const self = this;
      if (fromFilter == true) {
        self.UnitProgramAllocationDetailMasterData = filterMasterData;
      } else {
        self.UnitProgramAllocationDetailMasterData = $(
          "#" + self.UnitProgramAllocationDetailGridId
        )
          .data()
          .kendoGrid.dataSource.data();
      }
    },

    // Grid search
    filterGrid: function() {
      const self = this;
      const currentMasterdata = self.UnitProgramAllocationDetailMasterData;

      let filteredData = self._filterGrid(
        self.UnitProgramAllocationDetailMasterData,
        self.SearchUnitProgramAllocation.SearchData
      );

      $("#" + self.UnitProgramAllocationDetailGridId)
        .data("kendoGrid")
        .dataSource.data(filteredData);
      self.UpdateUnitProgramAllocationDetailMasterData(true, currentMasterdata);
    },

    // Toolbar Submit Forfeiture butt, Generate Document
    UnitProgramAllocationDetailToolBarClick(e) {
      const self = this;
      e.preventDefault();
      if (e.id === "btnBack") {
        self.backtoSummary();
      }
      if (e.id === "btnRefresh") {
        self.refreshGrid();
      }

      self._baseToolBarEvents(
        self.UnitProgramAllocationDetailGridId,
        ...arguments
      );
    },

    refreshGrid: function() {
      this.getProgramGridData();
    },

    async getProgramGridData() {
      const self = this;
      self.ProgramDetailGridData = [];

      let response = self.withFilter(
        self.BaseModelAllocation.list
      );

      let filteredAllocationData = await _.filter(
        response,
        function(obj) {
          return (
            obj.InvestmentId == self.investmentId &&
            obj.TaxYearQuarter.trim() == self.displayFields.Period.trim()
          );
        }
      );
      // console.log(filteredAllocationData);

      if (filteredAllocationData.length) {
        for (var i = 0; i < filteredAllocationData.length; i++) {
          let ProgramDetailData = {};
          
          self.displayFields.Investment = filteredAllocationData[0].InvestmentTitle;

          ProgramDetailData.PartnerId =
            filteredAllocationData[i].PartnerId;
          ProgramDetailData.PartnerName =
            filteredAllocationData[i].PartnerFullName;
            ProgramDetailData.UnitClass=
            filteredAllocationData[i].UnitClass;
            ProgramDetailData.UnitType=
            filteredAllocationData[i].UnitType;
          ProgramDetailData.FMVPercentage =
            filteredAllocationData[i].Percentage;
          ProgramDetailData.ProjectedValue =
            filteredAllocationData[i].ProjectedValue;
          ProgramDetailData.CurrentValue =
            filteredAllocationData[i].CurrentValue;

          self.ProgramDetailGridData.push(ProgramDetailData);
        }
        // console.log(self.ProgramDetailGridData);
      }
    }
  }
};
</script>